import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=04d4879c&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=ts&"
export * from "./Result.vue?vue&type=script&lang=ts&"
import style0 from "./Result.vue?vue&type=style&index=0&id=04d4879c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4879c",
  null
  
)

export default component.exports